import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import Pagination from "react-js-pagination";
import {apiService} from '../../common/apiCallService';
import Loading from '../Loading.js';
import {baseUrl} from '../../common/config.js';
import Menu from '../Menu.js'
import { Redirect } from 'react-router';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import RaisedButton from 'material-ui/RaisedButton';
import Paper from 'material-ui/Paper';
import IconButton from 'material-ui/IconButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import validator from 'validator';
import NewModulesNlessons from './NewModulesNlessons.js';
import * as actions from '../../store/actions/index';
import { connect } from 'react-redux';
import { createVirtualPageLoad, closeVirtualPage } from '../../common/commonService'

class ModuleNLessonList extends Component {

  constructor(props) {
    super(props)
    this.state = {
      max: 10,
      offset: 0,
      activePage: 1,
      totalCount: 0,
      sortBy: 'asc',
      currColumn: 'contentName',
      loginRedirect: false,
      loading: true,
      newModulesNlessonsFlag:false,
      openModuleNLessonDialog:false,
      indexList:[],
      data:[]
    }
    this.getAllClinicContent()
  }

  componentDidMount() {
    createVirtualPageLoad("/modulesAndLessonsList")
  }

  componentWillUnmount() {
    closeVirtualPage()
  }

  getAllClinicContent() {
    this.setState({loading: true})
      apiService(baseUrl + '/clinic/getAllClinicContent', {
        "max": this.state.max,
        "offset": this.state.offset,
        "sortBy": this.state.sortBy,
        "column": this.state.currColumn
      }, (data) => {
          this.setState({
            indexList: data.list,
            totalCount: data.count,
            loading: false
          })
      }, (data) => {
          this.setState({loading: false})
          if(data.status == 403) {
            localStorage.setItem("pathName", this.props.location.pathname)
            this.setState({loginRedirect: true})
          }
      })
  }

  deleteModuleOrLesson(id, type){
      this.setState({
        loading: true,
        id:id})
      apiService(baseUrl + '/clinic/deleteModuleOrLesson', {
        _id: id,
        type: type
      },  (data) => {
        this.setState({
          openModuleNLessonDialog:false,
          loading: false,
          msg: data.msg,
          open: true,
        })
      }, (data) => {
          this.setState({loading: false})
          if(data.status == 403) {
            localStorage.setItem("pathName", this.props.location.pathname)
            this.setState({loginRedirect: true})
          }
      })
  }

  getModuleOrLessonDtls = (id) => {
    this.setState({loading: true})
      apiService(baseUrl + '/clinic/getModuleOrLessonDtls', {
        "_id": id
      }, (data) => {
        this.setState({
          loading: false,
          data: data,
          openModuleNLessonDialog: true
        })
      }, (data) => {
          this.setState({loading: false})
          if(data.status == 403) {
            localStorage.setItem("pathName", this.props.location.pathname)
            this.setState({loginRedirect: true})
          }
      })
  }

  sorting(column) {
      this.setState({loading: true})
      if(column == this.state.currColumn) {
        if(this.state.sortBy == 'asc') this.state.sortBy = 'desc'
        else this.state.sortBy = 'asc'
      } else {
        this.state.sortBy = 'asc'
      }
      this.state.currColumn = column
      this.getAllClinicContent();
  }

  onPaginate = (pageNumber) => {
      this.state.activePage = pageNumber,
      this.state.offset  = (pageNumber - 1) * this.state.max
      this.getAllClinicContent()
  }

  newModulesNlessonsDialog = () =>{
    this.setState({
      openModuleNLessonDialog:false,
      data:[]
    })
    this.getAllClinicContent()
  }

  handleClose = () => {
    this.setState({open: false})
    this.getAllClinicContent()
   }

  closeModuleNLessonDialog = () => {
    this.setState({
      openModuleNLessonDialog: false,
      data:[]
    })
    this.refs.newModulesNlessons.closeModuleNLessonDialog()
  }

  render() {
    this.props.setHeaderTitle('Modules/Lesson List')
    const actions = [
        <FlatButton
          label="CANCEL"
          data-e2e="CANCEL"
          primary={true}
          onClick={this.closeModuleNLessonDialog}
        />,
        <FlatButton
          label="SUBMIT"
          data-e2e="SUBMIT"
          primary={true}
          onClick={() => this.refs.newModulesNlessons.validate()}
        />,
    ];
    return (
      <div>
          {this.state.loading
            ? <Loading/>
            : null}
          {this.state.loginRedirect && (<Redirect to={'/'}/> )}
          <div>
           <Dialog
              actions={<FlatButton label="Ok" data-e2e="OK" primary={true} keyboardFocused={true} onClick={this.handleClose}/>}
              modal={false}
              open={this.state.open}
              onRequestClose={this.handleClose}
            >
             {this.state.msg}
          </Dialog>
         </div>
          <br/>
          <div  className="container">
            <div style={{float:'right', paddingRight:'8px'}}>
             <RaisedButton label="Add"data-e2e="add-lessons" secondary={true} onClick={(event) =>this.setState({openModuleNLessonDialog:true})}/>
             <Dialog
               actions={actions}
               modal={true}
               title='New Module or Lesson'
               open={this.state.openModuleNLessonDialog}
               onRequestClose={this.closeModuleNLessonDialog}
             >
              <NewModulesNlessons  ref = "newModulesNlessons" newModulesNlessonsDialog ={this.newModulesNlessonsDialog} data = {this.state.data}  pathname={this.props.location.pathname}/>
             </Dialog>
            </div>
            <br/><br/>
            <Paper zDepth={1} rounded={false} className="resp-paper">
            <table className="resp-table resp-table-background" data-e2e="lesson-table">
              <thead className="resp-table-head">
                <tr className="resp-table-tr">
                  <th  onTouchTap={() => this.sorting('contentName')} className="resp-table-th" >Content Name&nbsp;
                    <i className="fa fa-sort "data-e2e="content-name"></i>
                  </th>
                  <th  onTouchTap={() =>  this.sorting('type')} className="resp-table-th">Type&nbsp;
                   <i className="fa fa-sort " data-e2e="type-sort"></i>
                  </th>
                  <th className="resp-table-th">Module Name&nbsp;</th>
                  <th  onTouchTap={() => this.sorting( 'order')} className="resp-table-th">Order&nbsp;
                    <i className="fa fa-sort "data-e2e="module-order"></i>
                  </th>
                  <th  className="resp-table-th"></th>
                  <th  className="resp-table-th"></th>
                 </tr>
               </thead>
               <tbody className="resp-table-body">
                 {this.state.indexList.map((item, key) => {
                   return (
                    <tr key={key} className="resp-table-tr">
                      <td className="ModuleNLesson resp-table-td" >{item.contentName}</td>
                      <td className="ModuleNLesson resp-table-td">{item.type}</td>
                      <td className="ModuleNLesson resp-table-td">{item.type != 'Course' ? item.parentId.contentName : '---'}</td>
                      <td className="ModuleNLesson resp-table-td">{item.order}</td>
                      <td className="ModuleNLesson resp-table-td" style={{padding: '0px'}} onTouchTap={()=>this.getModuleOrLessonDtls(item._id)}>
                       <IconButton iconClassName="fa fa-edit" data-e2e="moduleessonsEdit"/>
                      </td>
                      <td className="ModuleNLesson resp-table-td" style={{padding: '0px'}} onTouchTap={()=>this.deleteModuleOrLesson(item._id,item.type)} >
                        <IconButton iconClassName="fa fa-trash-o" data-e2e={item.contentName}/>
                      </td>
                   </tr>
                    )
                  })}
                </tbody>
            </table>
          </Paper>
          <div >
            {this.state.totalCount > 10
            ?<div style={{textAlign: "center"}}>
              <Pagination prevPageText='Prev'
                nextPageText='Next'
                firstPageText='First'
                lastPageText='Last'
                activePage={this.state.activePage}
                itemsCountPerPage={this.state.max}
                totalItemsCount={this.state.totalCount}
                pageRangeDisplayed={5}
                onChange={this.onPaginate}/>
            </div>
            : null}
        </div>
        </div>
     </div>
    )
  }

}

const mapDispatchToProps = dispatch => {
  return {
    setHeaderTitle : ( newTitle ) => dispatch(actions.setHeaderTitle( newTitle ))
  }
};

export default connect(null, mapDispatchToProps)(ModuleNLessonList);



/** WEBPACK FOOTER **
 ** ./src/components/Course/ModuleNLessonList.js
 **/